/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AuthorType {
  Motivated = 'Motivated',
  Unknown = 'Unknown',
  Verified = 'Verified',
}

export enum CartProductStatus {
  Default = 'Default',
  Error = 'Error',
  NoCreateCart = 'NoCreateCart',
  OutOfPriceLimit = 'OutOfPriceLimit',
  ReducedCount = 'ReducedCount',
  ShowSoldOutWarning = 'ShowSoldOutWarning',
  Sold = 'Sold',
  Success = 'Success',
  UseProductInCart = 'UseProductInCart',
  VoucherOnline = 'VoucherOnline',
}

export enum CartServiceType {
  Engraving = 'Engraving',
}

export enum CartStatusType {
  Default = 'Default',
  Error = 'Error',
  InternalError = 'InternalError',
  NotFound = 'NotFound',
  Success = 'Success',
  Warning = 'Warning',
}

export enum DiscountType {
  Absolute = 'Absolute',
  Percentage = 'Percentage',
  Unknown = 'Unknown',
}

export enum EGiftPackagingAllowedType {
  Brand = 'Brand',
  None = 'None',
  Product = 'Product',
}

export enum GiftType {
  BASIC = 'BASIC',
  GWP = 'GWP',
  SAMPLE = 'SAMPLE',
  SPECIAL = 'SPECIAL',
  TRY_IT_FIRST = 'TRY_IT_FIRST',
}

export enum MissVoteStatus {
  ALREADY_VOTED = 'ALREADY_VOTED',
  ERROR = 'ERROR',
  OK = 'OK',
}

export enum PathTemplate {
  Error = 'Error',
  HomePage = 'HomePage',
  NotFound = 'NotFound',
  ProductDetailSimple = 'ProductDetailSimple',
  SpecialPageComponent = 'SpecialPageComponent',
  Tryandbuy = 'Tryandbuy',
  Wishlist = 'Wishlist',
}

export enum ReviewOrderBy {
  DateTime = 'DateTime',
  Favorite = 'Favorite',
  Rating = 'Rating',
}

export enum Roles {
  Admin = 'Admin',
  Anonymous = 'Anonymous',
  Customer = 'Customer',
  Superuser = 'Superuser',
}

export enum RolloutStatusType {
  approved = 'approved',
  notSet = 'notSet',
  rejected = 'rejected',
}

export enum RoutineAssetEnum {
  Image = 'Image',
  Video = 'Video',
}

export enum StockAvailability {
  Last1 = 'Last1',
  Last2 = 'Last2',
  Last3 = 'Last3',
  Last4 = 'Last4',
  Last5 = 'Last5',
  MoreThan20 = 'MoreThan20',
  MoreThan5 = 'MoreThan5',
  OutOfStock = 'OutOfStock',
}

export enum SubjectType {
  BrandDiscount = 'BrandDiscount',
  CategoryDiscount = 'CategoryDiscount',
}

export enum VariantDisplayType {
  ColorPicker = 'ColorPicker',
  Default = 'Default',
  Select = 'Select',
  ShadesDrawer = 'ShadesDrawer',
  Thumbnail = 'Thumbnail',
  Tiles = 'Tiles',
}

export enum VoteAction {
  add = 'add',
  remove = 'remove',
}

export enum VoteType {
  dislike = 'dislike',
  like = 'like',
}

/**
 * A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.
 */
export enum __DirectiveLocation {
  ARGUMENT_DEFINITION = 'ARGUMENT_DEFINITION',
  ENUM = 'ENUM',
  ENUM_VALUE = 'ENUM_VALUE',
  FIELD = 'FIELD',
  FIELD_DEFINITION = 'FIELD_DEFINITION',
  FRAGMENT_DEFINITION = 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD = 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT = 'INLINE_FRAGMENT',
  INPUT_FIELD_DEFINITION = 'INPUT_FIELD_DEFINITION',
  INPUT_OBJECT = 'INPUT_OBJECT',
  INTERFACE = 'INTERFACE',
  MUTATION = 'MUTATION',
  OBJECT = 'OBJECT',
  QUERY = 'QUERY',
  SCALAR = 'SCALAR',
  SCHEMA = 'SCHEMA',
  SUBSCRIPTION = 'SUBSCRIPTION',
  UNION = 'UNION',
  VARIABLE_DEFINITION = 'VARIABLE_DEFINITION',
}

/**
 * An enum describing what kind of type a given `__Type` is.
 */
export enum __TypeKind {
  ENUM = 'ENUM',
  INPUT_OBJECT = 'INPUT_OBJECT',
  INTERFACE = 'INTERFACE',
  LIST = 'LIST',
  NON_NULL = 'NON_NULL',
  OBJECT = 'OBJECT',
  SCALAR = 'SCALAR',
  UNION = 'UNION',
}

export interface ArticlesQueryVariables {
  categories?: number[] | null;
  subCategories?: number[] | null;
  types?: number[] | null;
  kinds?: number[] | null;
  brandId?: number | null;
  masterProductCode?: string | null;
}

export interface CartProductInput {
  products?: (CartProductInputBody | null)[] | null;
}

export interface CartProductInputBody {
  id: number;
  count: number;
  isUpselling?: boolean | null;
  comparisonPrice?: boolean | null;
}

export interface CartServiceInput {
  type: CartServiceType;
  productId: string;
  count?: number | null;
  value: string;
}

export interface CustomerInput {
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  city?: string | null;
  zip?: string | null;
}

export interface MissVoteCustomerInput {
  name: string;
  email: string;
}

export interface MissVoteInput {
  missId: number;
  customer: MissVoteCustomerInput;
}

export interface ProductToCartInput {
  productId: number;
  count: number;
  isComparisonPrice: boolean;
}

export interface Rating {
  id?: number | null;
  ratingType?: string | null;
  score: number;
}

export interface RolloutStatusChange {
  productUrl: string;
  accept: boolean;
  variantType: string;
  comment?: string | null;
}

export interface tnbMakeOrderInput {
  campaignId?: number | null;
  name?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  city?: string | null;
  zipCode?: string | null;
  acceptedNewsletterOffer?: boolean | null;
  productIds: number[];
  sendConfirmationEmail?: boolean | null;
  smsCode?: string | null;
}

export interface tnbOrderInput {
  token: string;
  customer: CustomerInput;
  samples: (string | null)[];
}

export interface tnbSmsValidationInput {
  phoneNumber?: string | null;
  campaignId?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
